import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import {
  ActionsEnum,
  DrawerType,
  RydeUiUnit,
  selectedTableRowsIdsAtomFamily,
  useDrawers,
  useHasPermissions,
  useIsMobile,
} from "@ryde/shared";

import { FloatingMenuButton } from "../../floating-menu.styled";

const entity: RydeUiUnit = "passenger";

export const PassengerExpand: FC = () => {
  const selectedIds = useRecoilValue(selectedTableRowsIdsAtomFamily(entity));
  const { isMobile } = useIsMobile();
  const { openDrawer } = useDrawers();
  const { t } = useTranslation();
  const { hasPermissions: canSendMessage } = useHasPermissions({
    entity,
    action: ActionsEnum.SendMessage,
  });

  const onSendPassengersMessage = useEvent(() => {
    openDrawer({
      drawerProps: {
        type: DrawerType.BulkPassengersMessage,
        selectedPassengersIds: selectedIds,
      },
    });
  });

  if (!canSendMessage) {
    return null;
  }

  return (
    <FloatingMenuButton onClick={onSendPassengersMessage}>
      {!isMobile && <SVG_MUI.MessageLines3SVG className="pointer" />}
      <span>{t(`general.message`)}</span>
    </FloatingMenuButton>
  );
};
